import { render, staticRenderFns } from "./DashboardMediaCalls.vue?vue&type=template&id=39641929&"
import script from "./DashboardMediaCalls.vue?vue&type=script&lang=js&"
export * from "./DashboardMediaCalls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39641929')) {
      api.createRecord('39641929', component.options)
    } else {
      api.reload('39641929', component.options)
    }
    module.hot.accept("./DashboardMediaCalls.vue?vue&type=template&id=39641929&", function () {
      api.rerender('39641929', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/views/DashboardMediaCalls.vue"
export default component.exports